module.exports = __webpack_public_path__ + "static/media/browser_guide.bff909f5.svg";